import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Visibility, Edit } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeads } from "../../redux/Slice/LeadSlice";
import CustomTable1 from "../../components/table/CustomTable";
import { setLoading } from "../../redux/Slice/loaderSlice";
import DownloadIcon from "@mui/icons-material/Download";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { clearMessage } from "../../redux/Slice/message";
import { toast } from "sonner";
import CustomTable from "../../components/table/Table";

const columns = [
  { id: 'leadNo', label: 'Lead No', minWidth: 50, align:'start' },
  { id: 'company_name', label: 'Company Name', minWidth: 150, align:'start' },
  { id: 'contact_info', label: 'Contact Info', minWidth: 150, align:'start' },
  { id: 'enquiryType', label: 'Enquire Type', minWidth: 150, align:'start' },
  { id: 'leadStatus', label: 'Lead Status', minWidth: 150, align:'start' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, view: true}] },
];

const baseStyle = {
  padding: "6px 12px",
  borderRadius: "25px",
  fontWeight: "bold",
  textTransform: "uppercase",
  cursor: "pointer",
  transition: "all 0.3s ease",
  letterSpacing: "1px",
};

const getTagStyle = (type) => {
  switch (type?.toLowerCase()) {
    case "hot":
      return {
        ...baseStyle,
        backgroundColor: "#ff5252",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(255, 82, 82, 0.3)",
      };
    case "warm":
      return {
        ...baseStyle,
        backgroundColor: "#ffb74d",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(255, 183, 77, 0.3)",
      };
    case "cold":
      return {
        ...baseStyle,
        backgroundColor: "#29b6f6",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(41, 182, 246, 0.3)",
      };
    default:
      return {
        ...baseStyle,
        backgroundColor: "#e0e0e0",
        color: "#000",
        boxShadow: "0 4px 8px rgba(224, 224, 224, 0.5)",
      };
  }
};

const getStatusStyle = (status) => {
  switch (status?.toLowerCase()) {
    case "new":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #4caf50, #388e3c)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(76, 175, 80, 0.3)",
      };
    case "assigned":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #9c27b0, #7b1fa2)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(156, 39, 176, 0.3)",
      };
    case "follow-ups":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #ff9800, #f57c00)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(255, 152, 0, 0.3)",
      };
    case "demo scheduled":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #2196f3, #1976d2)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(33, 150, 243, 0.3)",
      };
    case "converted to customer":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #4caf50, #388e3c)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(76, 175, 80, 0.3)",
      };
    case "lost":
      return {
        ...baseStyle,
        background: "linear-gradient(145deg, #f44336, #d32f2f)",
        color: "#fff",
        boxShadow: "0 4px 8px rgba(244, 67, 54, 0.3)",
      };
    default:
      return {
        ...baseStyle,
        backgroundColor: "#e0e0e0",
        color: "#000",
        boxShadow: "0 4px 8px rgba(224, 224, 224, 0.5)",
      };
  }
};


const AllLeads = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { leads, totalCount } = useSelector((state) => state.leads);
  const message = useSelector((state) => state.message);

  const transformLeads = (leads) =>
      leads.map((lead) => ({
        _id:lead?._id,
        leadNo: lead?.lead_id,
        company_name: lead?.companyName || "N/A",
        contact_info: lead?.contactPerson[0]?.email + " / " + lead?.contactPerson[0]?.phoneNumber || "N/A", 
        enquiryType: lead?.enquiryType || "N/A",style: getTagStyle(lead?.enquiryType),
        leadStatus: lead?.leadStatus || "N/A", style: getStatusStyle(lead?.leadStatus),  
        action: "", 
      }));

      const modifiedRows = leads ? transformLeads(leads) : [];

  // const columns = [
  //   {
  //     field: "lead_id",
  //     headerName: "Lead No",
  //     render: (value) => <strong>{value}</strong>,
  //   },
  //   {
  //     field: "contactPerson",
  //     headerName: "Contact Person",
  //     render: (value, row) => (
  //       <>
  //         <p>{row?.contactPerson[0]?.name}<br />({row?.companyName})</p>
  //       </>
  //     ),
  //   },
  //   {
  //     field: "contactInfo",
  //     headerName: "Contact Info",
  //     render: (value, row) => (
  //       <>
  //         <div>Email: {row?.contactPerson[0]?.email}</div>
  //         <div>Phone: {row?.contactPerson[0]?.phoneNumber}</div>
  //       </>
  //     ),
  //   },
  //   {
  //     field: "enquiryType",
  //     headerName: "Enquire Type",
  //     render: (value) => (
  //       <span
  //         style={{
  //           ...getTagStyle(value),
  //           padding: "4px 8px",
  //           borderRadius: "20px",
  //           fontSize: "14px",
  //           textTransform: "uppercase",
  //           letterSpacing: "0.8px", 
  //           cursor: "pointer",
  //         }}
  //       >
  //         {value}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "leadStatus",
  //     headerName: "Status",
  //     render: (value) => (
  //       <span
  //         style={{
  //           ...getStatusStyle(value),
  //           padding: "4px 8px",
  //           borderRadius: "20px",
  //           fontSize: "14px",
  //           textTransform: "uppercase",
  //           letterSpacing: "0.8px", 
  //           cursor: "pointer",
  //         }}
  //       >
  //         {value}
  //       </span>
  //     ),
  //   },
    
  // ];


  const handleEdit = (row) => {
    if (row._id) {
      navigate(`/lead/${row._id}`);
    } else {
      console.log("No lead ID found for this row", row);
    }
};

const handleView = (row) => {
    if (row._id) {
      navigate(`/lead/${row._id}`);
    } else {
      console.log("No lead ID found for this row", row);
    }
  };
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setPage(1);
    };
    
  const handleExport = () => {
    console.log("Exporting data...");
  };

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])


  
  useEffect(() => {
      // dispatch(setLoading(true));
      dispatch(fetchLeads({ page: page, limit: rowsPerPage, searchTerm })) 
          // .then(() => {
          //     dispatch(setLoading(false));
          // })
          // .catch(() => {
          //     dispatch(setLoading(false));
          // });
  }, [dispatch, page, rowsPerPage, searchTerm]);

  return (
    <div className="content">
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Lead <Typography component="span">({totalCount})</Typography>
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TextField
            size="small"
            placeholder="Search by Lead Name"
            onChange={handleSearch}
            fullWidth
            sx={{ maxWidth: 300, mr: 2 }}
          />
          <Link to="/lead/create">
          <Button variant="contained" startIcon={<PersonAddAlt1Icon />} onClick={handleExport} sx={{ ml: 2, px: 3 }}>
            Add
          </Button>
          </Link>
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleExport} sx={{ ml: 2, px: 3 }}>
            Export
          </Button>
        </Box>
      </Box>

        <CustomTable
             columns={columns}
             rows={modifiedRows}
             page={page}
             setPage={setPage}
             rowsPerPage={rowsPerPage}
             setRowsPerPage={setRowsPerPage}
             totalCount={totalCount}
             handleEdit={handleEdit}
             handleView={handleView}
           />
    </div>
  );
};

export default AllLeads;
